import React, {
  useCallback,
  useEffect,
  useState
}                                  from 'react';
import {
  useDispatch,
  useSelector
}                                  from "react-redux";
import { ApplicationState }        from "../../../store";
import { triggerExportStatusList } from "../../../store/layouts/actions";
import { LayoutState }             from "../../../store/layouts/types";
import { getAviList }              from '../../../store/recordings/actions';
import { RecordingState }          from "../../../store/recordings/types";
import { IconComponent }           from "../../reusable/simpleComponents";


const ExportListUIComponent = () => {
  const [aviTitle, setTitle] = useState('');
  const [isHover, setIsHover] = useState(false);
  const {exportStatusListOpened} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const {avilist} = useSelector<ApplicationState, RecordingState>(state => state.recording);
  const dispatch = useDispatch();

  const titleCreation = useCallback(() => {
    let uploading = avilist.filter((item: { completion: number; }) => item.completion < 1000 && item.completion >= 0);
    let queued = avilist.filter((item: { completion: number; }) => item.completion === -1);
    let title = uploading.length > 0 ? `${uploading.length} Exports Pending.` : '';
    title += avilist.length - uploading.length > 0 ? `${avilist.length - uploading.length} Exports Available for Download.` : 'No exports available for download.';
    title += queued.length ? `${queued.length} Queued.` : '';
    setTitle(title);
  }, [avilist]);

  useEffect(() => {
    titleCreation();
  }, [titleCreation]);

  const handler = () => {
    dispatch(triggerExportStatusList())
  };

  const hoverHandler = () => {
    !isHover && dispatch(getAviList());
    setIsHover(!isHover);
  };

  const aviListInterval = useCallback(() => {
    return setInterval(() => {
      dispatch(getAviList());
    }, 3000);
  }, [dispatch]);

  useEffect(() => {
    const getAviListTimer = aviListInterval();
    !isHover && clearInterval(getAviListTimer);
    return () => clearInterval(getAviListTimer);
  }, [aviListInterval, isHover]);

  return (
    <IconComponent
      classValue={exportStatusListOpened ? 'download active icon' : 'download icon'}
      hoverHandler={hoverHandler}
      handler={handler}
      title={aviTitle}
    />
  )

};

export default ExportListUIComponent